import React from 'react';
import Styles from './styles.module.sass';
import ModalMovimientos from '../Modal';
import { ModalError } from 'newComponents/Error/ErrorModal'
import { currencyFormat, dateFormat } from 'newFunctions/dateFormat'
import { Error500 } from 'newComponents/Error/Error500'
import { useMovimientosModal } from 'newHooks/useMovimientos';
import SectionLayout from 'newComponents/Layout/SectionLayout';

const MovimientosDesktop = (props) => {
    
    const {
        respMovements,
        setPeriod,
        errorCode
    } = props

    const {
        billDate,
        opcionSeleccionada,
        revolvente,
        mostrarPeriodo,
        periodos,
        showModal,
        aceptar,
        cerrar,
        handleClose,
        setMostrarPeriodo,
        setOpcionSeleccionada,
        handleMostrarPeriodos
    } = useMovimientosModal(errorCode, respMovements, setPeriod)

    const moduleOptions = <ul className={Styles?.ulPeriodos}>
        {!opcionSeleccionada
            ? <li onClick={handleMostrarPeriodos} id={periodos[0]?.periodo}>{periodos[0]?.periodo}</li>
            : <li onClick={handleMostrarPeriodos} id={opcionSeleccionada}>{opcionSeleccionada}</li>
        }
    </ul>

    return (
        <>
            {errorCode >= 500
                ? <Error500 />
                :
                    <SectionLayout title="Movimientos" action={moduleOptions}>
                        <ul className={Styles?.ulMovimientos}>
                            {revolvente && revolvente.map((opc, i) =>
                                <li className={Styles?.lidesk} key={i}>
                                    <p className={Styles?.title}>{opc.descripcion}</p>
                                    {opc.movimientos.map((opc2, i) =>
                                        <div className={Styles?.infoMouvements} key={i}>
                                            <div className={opc2?.estatus === 'abono' ? `${Styles?.classIcon} ${Styles?.classAbono}` :  `${Styles?.classIcon} ${Styles?.classCargo}`}></div>
                                            <p className={Styles?.name}>{opc2?.transaction_description}</p>
                                            <p className={Styles?.estatus}> {opc2?.estatus}</p>
                                            <p className={Styles?.monto}>{currencyFormat(opc2?.importe)}</p>
                                            <p className={Styles?.fecha}>{dateFormat(opc2?.date_activity)}</p>
                                        </div>
                                    )}
                                </li>
                            )}
                        </ul>
                    </SectionLayout>
                }

                {mostrarPeriodo === true &&
                    <ModalMovimientos onClose={mostrarPeriodo} setMostrarPeriodo={setMostrarPeriodo}
                        type="" title="Periodo" cerrar={cerrar} aceptar={aceptar} periodos={periodos}
                        setOpcionSeleccionada={setOpcionSeleccionada}
                    />
                }
                {showModal &&
                    <ModalError errorCode={errorCode} handleClose={handleClose} />
                }
        </>
    )
}

export default MovimientosDesktop